import { Component, output, signal } from '@angular/core';
import { DsButtonModule, DsModalModule } from '@bmw-ds/components';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pure-terms-and-conditions-modal',
  imports: [DsModalModule, TranslateModule, DsButtonModule],
  templateUrl: './terms-and-conditions-modal.component.html',
  styleUrl: './terms-and-conditions-modal.component.scss',
})
export class TermsAndConditionsModalComponent {
  modalIsOpen = signal<boolean>(true);
  closed = output<void>();

  modalDismissed(): void {
    this.modalIsOpen.set(false);
    this.closed.emit();
  }
}
